import React from 'react'

import { Formik } from 'formik'

import Yup from '_zari/validation/_yup'

import { ZariContext } from '_zari/context'

import { Col, Row, Portlet, Button } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'
import * as Tables from './tables'

const ValidationSchema = Yup.object().shape({
  serieDocumento: Yup.string().max(4).notRequired(),
  numeroDocumento: Yup.number().required()
})

const ConsultasDocumentosPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [listaDocumentos, setListaDocumentos] = React.useState([])

  const formInitialValues = React.useMemo(() => {
    return {
      serieDocumento: '',
      numeroDocumento: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Consultando informacion con filtros ingresados.')

      AsientoContableService.consultaGeneralDocumentos(data)
        .then(({ data }) => {
          if (data) {
            setListaDocumentos(data)
          } else {
            setListaDocumentos([])
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Consulta De Documentos' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
              {({ errors, touched, isSubmitting, handleSubmit }) => (
                <>
                  <FormGroups.SerieDocumentoFormGroup
                    iError={errors.serieDocumento}
                    iTouched={touched.serieDocumento}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.NumeroDocumentoFormGroup
                    iError={errors.numeroDocumento}
                    iTouched={touched.numeroDocumento}
                    fIsSubmitting={isSubmitting}
                  />
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button disabled={isSubmitting} onClick={handleSubmit}>
                        Consultar
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </Formik>
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col md={12}>
            <Tables.DocumentosEncontradosTable filas={listaDocumentos} />
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ConsultasDocumentosPage)
